import { useEffect } from "react";

function upsertMeta(attr, key, content) {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertLink(rel, href) {
    let el = document.head.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "/", jsonLd }) {
    useEffect(() => {
        const full = `${title} — Phoebus AI`;
        document.title = full;
        const url = `https://phoebusai.com${path}`;
        if (description) {
            upsertMeta("name", "description", description);
            upsertMeta("property", "og:description", description);
            upsertMeta("name", "twitter:description", description);
        }
        upsertMeta("property", "og:title", full);
        upsertMeta("name", "twitter:title", full);
        upsertMeta("property", "og:url", url);
        upsertLink("canonical", url);

        let script;
        if (jsonLd) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.text = JSON.stringify(jsonLd);
            script.setAttribute("data-seo-jsonld", "true");
            document.head.appendChild(script);
        }
        return () => {
            if (script) document.head.removeChild(script);
        };
    }, [title, description, path, jsonLd]);

    return null;
}
